<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
  </button>
</div>
<div class="modal-body">
  <app-ace-table columnMode="flex"
                 [columns]="columns"
                 [rows]="data"
                 [rowHeight]="30"
                 [scrollbarV]="true"
                 [showPageLimitControl]="false"/>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary me-auto" (click)="exportCSV()">{{ 'Export CSV' | messageTranslate }}</button>
  <button type="button" ngbAutofocus class="btn btn-secondary" (click)="activeModal.dismiss('Close')">{{ 'Close' | messageTranslate }}</button>
</div>
